import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Configuration for development
    gamesCasino, // Games configuration for casino
    profile, // User profile configuration
    providersCasino, // Providers configuration for casino
} from 'config/config'; // Importing various configuration settings

/**
 * Class representing the view for machine categories.
 */
export default class tableMachineCategoriesView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: 'dbllist', // Double list view
            id: 'dbllist', // ID for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Categorías no agregados'), // Left label for unadded categories
            labelRight: _('Categorías Agregados'), // Right label for added categories
            data: [], // Initial data for the list
        };
        return {
            view: 'form', // Form view
            id: 'f1', // ID for the form
            rows: [
                {
                    view: 'forminput', // Input field in the form
                    name: 'access', // Name of the input
                    body: list1, // Body of the input
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Alignment of the label
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to hold values
        const cur_user = this.getParam('user', true); // Current user parameter
        var categorie = ''; // Variable to hold category
        this.on(this.app, 'machineCategories:filter', (filterData) => {
            // Event listener for filtering categories
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API request
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Categorie') {
                        categorie = object[i][1]; // Set category
                    }
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dbllist').$$('left').clearAll(); // Clear left list
            $$('dbllist').setValue([]); // Reset selected values
            webix
                .ajax() // AJAX request to fetch machine categories
                .get(
                    devConfig.geturlApi() + 'MachineCategories/GetGroupMachineCategories', // API endpoint
                    string1, // Query string
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handler
                            webix.message('Error! '); // Display error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handler
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors in response
                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                $$('dbllist').setValue([]); // Reset selected values
                                $$('dbllist').parse(data.Data.ExcludedCategoriesList); // Parse excluded categories
                                $$('dbllist').setValue(data.Data.IncludedCategoriesList); // Set included categories
                                values = data.Data.IncludedCategoriesList; // Store included categories
                            } else {
                                webix.message('Error! '); // Display error message
                            }
                        },
                    },
                );
        });
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            // Event listener for changes in the double list
            var array1 = values.split(','); // Split included categories into an array
            var array2 = $$('dbllist').getValue().split(','); // Split currently selected categories into an array
            var arrayAgregados = []; // Array for added categories
            var arrayEliminados = []; // Array for removed categories
            array2.forEach(function (obj) {
                // Iterate through currently selected categories
                var found = array1.find(function (element) {
                    // Check if category was previously included
                    return element == obj;
                });
                if (found != undefined) {
                    // If found, do nothing
                } else {
                    arrayAgregados.push(obj); // Add to added categories
                }
            });
            array1.forEach(function (obj) {
                // Iterate through previously included categories
                var found = array2.find(function (element) {
                    // Check if category is still selected
                    return element == obj;
                });
                if (found == undefined) {
                    // If not found, add to removed categories
                    arrayEliminados.push(obj);
                } else {
                }
            });
            values = $$('dbllist').getValue(); // Update values with currently selected categories
            webix
                .ajax() // AJAX request to save changes
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'MachineCategories/SaveGroupMachineCategories', // API endpoint
                    '{"IdMachine":"' +
                        cur_user +
                        '","Categorie":"' +
                        categorie +
                        '","IncludedCategoriesList":"' +
                        arrayAgregados +
                        '","ExcludedCategoriesList":"' +
                        arrayEliminados +
                        '"}', // Request body
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handler
                            webix.message(_('Error! ')); // Display error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handler
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors in response
                                webix.message(_('Categoría Máquina Editado')); // Display success message
                            } else {
                                webix.message(_('Error! ')); // Display error message
                            }
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
